export default __webpack_public_path__ + "static/media/008-long coat.5343556a.svg";